import React from "react";

const ReturnIcon = ({ width = "14px", height = "14px", fill = "#EF4444" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 5.33333V8.66667C2 11.1807 2.00067 12.4373 2.78133 13.2187C3.562 14 4.81933 14 7.33333 14H8.66667C11.1807 14 12.4373 13.9993 13.2187 13.2187C14 12.438 14 11.1807 14 8.66667V5.33333M2 5.33333H14M2 5.33333L2.57667 4.05133C3.02467 3.05667 3.248 2.56 3.70133 2.28C4.15467 2 4.73667 2 5.9 2H10.1C11.2633 2 11.8447 2 12.2987 2.28C12.752 2.56 12.9753 3.05667 13.4233 4.05133L14 5.33333M8 5.33333V2"
        stroke={fill}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.66683 8.99996H9.3335C9.68712 8.99996 10.0263 9.14044 10.2763 9.39048C10.5264 9.64053 10.6668 9.97967 10.6668 10.3333C10.6668 10.6869 10.5264 11.0261 10.2763 11.2761C10.0263 11.5262 9.68712 11.6666 9.3335 11.6666H8.66683M6.66683 7.66663L5.3335 8.99996L6.66683 10.3333"
        stroke={fill}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ReturnIcon;
